import type { SugarmateError } from "@tandemdiabetes/sugarmate-api-react-client"
import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  code?: SugarmateError["code"];
  status?: SugarmateError["status"];
}

export function InviteFollowerErrorToast(props: Props) {
  const {
    id, code,
  } = props

  const polyglot = usePolyglot()

  const body = useMemo(
    () => {
      switch (code) {
        case 1001: // Max followers reached
          return "max_followers_body"
        case 1002: // User already invited
          return "already_invited_body"
        case 1003: // consent required
          return "consent_required_body"
        case 1024: // User already following
          return "already_following_body"
        default:
          return "default_body"
      }
    },
    [code],
  )

  return (
    <Toast
      stylePreset="error"
      body={polyglot.t(`toasts.invite_follower_error.${body}`)}
      id={id}
    />
  )
}